import JsonData from '../../data/data.json';

import {ExpertiseScreen} from './ExpertiseScreen';
import {HeroSection} from './HeroSection';
import {QuickStats} from './QuickStats';
import {ThirdSection} from './ThirdSection';

const HomeScreen = () => {
  return(
    <div className={'bg-primary-950'}>
      <HeroSection data={JsonData.HeroSection} />
      <ExpertiseScreen data={JsonData.ExpertiseSection} />
      <ThirdSection data={JsonData.ThirdSection} />
      <QuickStats className={'mt-auto'} data={JsonData.QuickStats} />
    </div>
  );
};

export default HomeScreen;
